/* store/modules/message */
const message = {
    message: null,
    show: false,
    type: null
}

const state = {
    message: message
}

const mutations = {
    SET_MESSAGE(state, data) {
        state.message = data
    }
}

const actions = {
    resetMessage: ({ commit }) => {
        commit('SET_MESSAGE', message)
    },

    setMessage: ({ commit }, value) => {
        commit('SET_MESSAGE', value)
    }
}

const getters = {
    getMessage: state => {
        return state.message
    },

    getMessageMsg: state => {
        return state.message.message
    },

    getMessageShow: state => {
        return state.message.show === null ? false : state.message.show
    },

    getMessageType: state => {
        return state.message.type === null ? 'info' : state.message.type
    }
}

export default {
    state,
    mutations,
    actions,
    getters
}